export enum CssUnits {
  Px = 'px',
  Em = 'em',
  Rem = 'rem',
  Percent = '%',
  Pt = 'pt'
}
